import type { HTMLAttributes } from 'react'

import styles from './Spinner.module.css'

export function Spinner({ className = '', ...props }: HTMLAttributes<HTMLSpanElement>) {
  return <span className={`${styles.spinner} ${className}`} role="status" aria-label="加载中" {...props} />
}
